import { KeyboardArrowRight } from '@mui/icons-material';
import {
  List,
  ListItemButton,
  ListItemIcon,
  Stack,
  Typography,
} from '@mui/material';
import { useEntityActions } from 'api/entity';
import { useWorkspaceId } from 'api/providers/workspaceProvider';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { SearchQuery } from '../processQuery';

export function SearchCreateEntity(props: {
  value: SearchQuery;
  onClick: (open: boolean) => void;
}) {
  const { value, onClick: setOpen } = props;

  const { createEntity } = useEntityActions();
  const workspaceId = useWorkspaceId();
  const navigate = useNavigate();

  const params = useParams();
  const entityId = params.id;

  const [focus] = useState(0);

  const parentEntityId =
    value.queryOptions.type === 'children'
      ? value.queryOptions.entityId
      : value.queryOptions.type === 'currentEntity'
        ? entityId
        : undefined;

  useEffect(() => {
    const func = async (e: KeyboardEvent) => {
      if (e.key === 'Enter' && focus === 0 && value.queryText) {
        setOpen(false);
        const response = await createEntity({
          name: value.queryText.slice(1).trim(),
          parent: parentEntityId,
          type: 'task',
        });
        const id = await response.text();
        navigate(`/workspace/${workspaceId}/entity/${id}`);
      }
    };
    window.addEventListener('keydown', func);
    return () => {
      window.removeEventListener('keydown', func);
    };
  }, [
    createEntity,
    focus,
    navigate,
    parentEntityId,
    setOpen,
    value.queryOptions.type,
    value.queryText,
    workspaceId,
  ]);

  return (
    <List disablePadding>
      <ListItemButton
        selected={focus === 0}
        onClick={(e) => {
          if (e.metaKey || e.ctrlKey) {
            return;
          }
          setOpen(false);
        }}
      >
        <Stack flexGrow={1}>
          <Typography variant="h6">Create new Task</Typography>
          <Typography>{value.queryText.slice(1).trim()}</Typography>
        </Stack>
        <ListItemIcon>
          <KeyboardArrowRight />
        </ListItemIcon>
      </ListItemButton>
    </List>
  );
}
